<template>
  <v-container>
    <v-row>
      <v-col class="mt-6 ml-4">
        <h1 class="display-1 font-weight-bold">動画一覧</h1>
      </v-col>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="videos"
          :loading="loading"
          :search="search"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-text-field
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                label="検索"
                single-line
                hide-details
                clearable
                class="shrink"
                @keyup.enter.native="doSearch"
                @click:clear="clearSearch"
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-btn
                color="info"
                class="mr-2"
                @click="fetch()"
              >
                <v-icon left>
                  mdi-reload
                </v-icon>
                更新
              </v-btn>
              <v-btn
                color="success"
                @click="openNew()"
              >
                <v-icon left>
                  mdi-plus
                </v-icon>
                新規
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`item.title`]="{ item }">
            <div class="d-flex align-center my-2">
              <v-img
                :src="`/v/${item.uuid}/thumb`"
                class="grey darken-2"
                height="135"
                width="240"
                max-width="240"
                contain
              ></v-img>
              <v-row class="ml-1">
                <v-col>
                  <div class="body-1 font-weight-medium">
                    {{ item.title }}
                  </div>
                  <div class="body-2">
                    {{ item.uuid }}
                    <v-btn icon @click.stop="copyItem(item)">
                      <v-icon small >
                        mdi-content-copy
                      </v-icon>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </div>
          </template>
          <template v-slot:[`item.created_at`]="{ item }">
            {{ item.created_at | moment }}
          </template>
          <template v-slot:[`item.state`]="{ item }">
            <strong v-if="item.state==='PENDING'" class="warning--text">待機中</strong>
            <strong v-else-if="item.state==='STARTED'" class="info--text">変換中</strong>
            <strong v-else-if="item.state==='SUCCESS'" class="success--text">完了</strong>
            <strong v-else-if="item.state==='FAILURE'" class="error--text">失敗</strong>
          </template>
          <template v-slot:[`item.attachment`]="{ item }">
            {{ item.attachment ? item.attachment : 'なし' }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon @click="playItem(item)" class="ml-2">
              mdi-play-circle
            </v-icon>
            <v-icon @click="editItem(item)" class="ml-2">
              mdi-pencil
            </v-icon>
            <v-icon @click="deleteItem(item)" class="ml-2">
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <delete-video-dialog ref="delete" @success="fetch"></delete-video-dialog>
  </v-container>
</template>

<script>
import axios from "axios"
import moment from "moment"
import DeleteVideoDialog from '@/components/DeleteVideoDialog'

export default {
  components: {
    DeleteVideoDialog
  },
  data() {
    return {
      loading: false,
      search: '',
      headers: [
        { text: 'タイトル', value: 'title' },
        { text: '登録日', value: 'created_at' },
        { text: '添付資料', value: 'attachment' },
        { text: '動画変換', value: 'state' },
        { text: '操作', value: 'actions', sortable: false, width: 160 },
      ],
      videos: []
    }
  },
  filters: {
    moment(value) {
      return moment(value).format('YYYY/MM/DD HH:mm:ss');
    },
  },
  created() {
    this.fetch()
  },
  methods: {
    async fetch() {
      this.loading = true
      const accessToken = await this.$auth.getTokenSilently()
      await axios
        .get("/api/videos", {
          headers: {
            Authorization: `Bearer ${accessToken}`
          },
        })
        .then(response => {
          this.videos = response.data
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    editItem(item) {
      this.$router.push({name: 'Edit', params: { uuid: item.uuid }})
    },
    openNew() {
      this.$router.push({name: 'New'})
    },
    clearSearch() {
      this.search = ''
    },
    copyItem(item) {
      navigator.clipboard.writeText(item.uuid)
      .then(() => {
        console.log('copied!')
      })
      .catch(e => {
        console.log(e)
      })
    },
    deleteItem(item) {
      this.$refs.delete.open(item)
    },
    playItem(item) {
      this.$router.push({name: 'Play', params: { uuid: item.uuid }})
    }
  }
}
</script>